<template>
  <div class="right-float d-none d-lg-block">
    <div class=" d-flex flex-column">
      <div id="float_weapp_qr" class="d-flex flex-column float-icon">
        <img src="../assets/icon_float_qr_hover.png" tabindex="0"/>
        <label>小程序</label>
      </div>
      <b-popover target="float_weapp_qr" triggers="hover">
        <img src="../assets/img_weapp_qr.png"/>
        <div class="text-center">微信扫一扫，立即体验小程序</div>
      </b-popover>

      <div id="float_wx_qr" class="d-flex flex-column float-icon">
        <img src="../assets/icon_float_wx_hover.png" tabindex="1"/>
        <label>公众号</label>
      </div>
      <b-popover target="float_wx_qr" triggers="hover">
        <img src="../assets/img_float_wxpub_qr.png"/>
        <div class="text-center">微信扫一扫，关注微信公众号</div>
      </b-popover>

      <div id="float_andr_download" class="d-flex flex-column float-icon" @click="downloadApp">
        <img src="../assets/icon_float_andr_hover.png"/>
        <label>Android</label>
      </div>
      <b-popover target="float_andr_download" triggers="hover">
        <div class="text-center">点击下载 APP</div>
        <!-- <div class="text-center">即将上线</div> -->
      </b-popover>

      <transition name="fade">
        <img id="float_goto_top" v-if="showGoToTop"
             src="../assets/icon_float_gotop.png"
             style="margin-top: 150px;cursor: pointer"
             v-on:click="scrollToTop"/>
      </transition>
    </div>
  </div>
</template>

<script>
  import bPopover from 'bootstrap-vue/es/components/popover/popover';
  import Bus from '../Bus';

  export default {
    name: "RightFloatBar",
    components: {'b-popover': bPopover},

    data() {
      return {showGoToTop: false}
    },

    methods: {
      handleScroll() {
        this.showGoToTop = window.scrollY > window.innerHeight / 2;
      },

      scrollToTop() {
        Bus.$emit('pageScrollTop');
      },

      downloadApp() {
        window.location.href = "https://sj.qq.com/myapp/detail.htm?apkName=cn.yimulixin.jiangehui";
      },
    },

    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
  }
</script>

<style scoped lang="scss">
  .right-float {
    position: fixed;
    z-index: 100;
    right: 10%;
    top: calc(50% - 240px);
  }

  #float_goto_top:hover {
    content: url("../assets/icon_float_gotop_hover.png");
  }

  .float-icon {
    width: 80px;
    height: 80px;
    border: #ddd solid 1px;
    margin-top: -1px;
    padding: 10px;
    background-color: white;
  }

  .float-icon > img {
    align-self: center;
    margin: auto;
    max-width: 36px;
  }

  .float-icon > label {
    font-size: 14px;
    color: #888;
    margin-top: 5px;
  }

  #float_andr_download > img:hover {
    content: url("../assets/icon_float_andr_hover.png");
  }
</style>



// WEBPACK FOOTER //
// src/components/RightFloatBar.vue